import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';


@Component({
  selector: 'app-search',
  imports: [TranslatePipe, CommonModule, FormsModule],
  templateUrl: './search.html',
  styleUrl: './search.css'
})
export class Search {
  @Input() placeholder: string = 'TABLE.SEARCH';
  @Input() extraClass: string = '';
  @Output() searchChange = new EventEmitter<string>();

  searchTerm = '';

  onSearch(value: string) {
    this.searchChange.emit(value);
  }

  removeSearch(event: Event) {
    event.stopPropagation();
    this.searchTerm = '';
    this.searchChange.emit('');
  }
}
